var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_c('h1', {
    staticClass: "text-primary"
  }, [_vm._v("折價券兌換")]), _c('h2', [_vm._v("電商通路選擇")]), _c('div', {
    staticClass: "p-4"
  }, [_c('p', {
    staticClass: "text-left"
  }, [_vm._v(" 2022/04/01-2022/12/30，至指定合作實體通路，購買好奇裸感好動褲(M-XXL)，單箱／包即可立即折扺$50元 ")]), _vm.isAvailable('pchome') ? _c('a', {
    directives: [{
      name: "b-modal",
      rawName: "v-b-modal.modal-confirm",
      modifiers: {
        "modal-confirm": true
      }
    }],
    staticClass: "my-2 d-inline-block",
    on: {
      "click": function click($event) {
        $event.preventDefault();
        _vm.type = 'pchome';
      }
    }
  }, [_vm._m(0)]) : _vm._e(), _vm.isAvailable('momo') ? _c('a', {
    directives: [{
      name: "b-modal",
      rawName: "v-b-modal.modal-confirm",
      modifiers: {
        "modal-confirm": true
      }
    }],
    staticClass: "my-2 d-inline-block",
    on: {
      "click": function click($event) {
        $event.preventDefault();
        _vm.type = 'momo';
      }
    }
  }, [_vm._m(1)]) : _vm._e(), _vm.isAvailable('shopee') ? _c('a', {
    directives: [{
      name: "b-modal",
      rawName: "v-b-modal.modal-confirm",
      modifiers: {
        "modal-confirm": true
      }
    }],
    staticClass: "my-2 d-inline-block",
    on: {
      "click": function click($event) {
        $event.preventDefault();
        _vm.type = 'shopee';
      }
    }
  }, [_vm._m(2)]) : _vm._e(), _c('router-link', {
    staticClass: "button my-4 d-inline-block w-auto",
    attrs: {
      "to": {
        name: 'LiffHuggiesCoupons'
      }
    }
  }, [_c('span', {
    staticClass: "h5 mb-0 font-weight-bold text-primary"
  }, [_vm._v("返回上一頁")])])], 1), _c('b-modal', {
    attrs: {
      "id": "modal-confirm",
      "size": "sm",
      "hide-footer": "",
      "hide-header": "",
      "centered": ""
    }
  }, [_c('div', {
    staticClass: "p-2"
  }, [_c('p', {
    staticClass: "my-4 text-center"
  }, [_vm._v(" 您確定要兌換折價券嗎？ "), _c('br'), _vm._v("點選確認後 30 分鐘內需使用完畢 ")]), _c('div', {
    staticClass: "d-flex"
  }, [_c('button', {
    staticClass: "button mr-3",
    on: {
      "click": function click($event) {
        return _vm.$bvModal.hide('modal-confirm');
      }
    }
  }, [_c('span', {
    staticClass: "h4 mb-0 font-weight-bold text-primary"
  }, [_vm._v("取消")])]), _c('a', {
    staticClass: "button",
    on: {
      "click": function click($event) {
        return _vm.submitRedeem();
      }
    }
  }, [_c('span', {
    staticClass: "h4 mb-0 font-weight-bold text-primary"
  }, [_vm._v("確定使用")])])])])])], 1);
}
var staticRenderFns = [function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "router w-50 m-auto"
  }, [_c('img', {
    staticClass: "img-fluid",
    attrs: {
      "src": require("./images/router_pchome.jpg")
    }
  })]);
} /* staticRenderFnsSpliter */, function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "router w-50 m-auto"
  }, [_c('img', {
    staticClass: "img-fluid",
    attrs: {
      "src": require("./images/router_momo.jpg")
    }
  })]);
} /* staticRenderFnsSpliter */, function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "router w-50 m-auto"
  }, [_c('img', {
    staticClass: "img-fluid",
    attrs: {
      "src": require("./images/router_shopee.png")
    }
  })]);
}]

export { render, staticRenderFns }